<template>
  <div class="flex justify-end items-center h-14 relative z-20">
    <slot />
  </div>
</template>

<script>
/**
 * Header.vue
 */
export default {
  data () {
    return {}
  },
  props: {
    showChat: {
      type: Boolean,
      default: true,
    }
  },
}
</script>
